const headAlternate = ([x]) => x;

/**
 * head :: [a] -> [a]
 *
 * @param {T[]} xs
 * @return {T[]}
 */
export const head = (xs) => xs.slice(0, 1);
